const SearchForm = () => {
  const inputSearch = document.querySelector('.form-page-search .inputsearch')
  const cleanSearch = document.querySelector('.form-page-search .clean')
  const searchSearch = document.querySelector('.form-page-search .search')

  cleanSearch.addEventListener('click', () => {
    inputSearch.value = ''
    inputSearch.focus()

    cleanSearch.classList.add('hide')
    searchSearch.classList.remove('hide')
  })
}

export default SearchForm
